module.exports = __webpack_public_path__ + "images/emoji/taxi.a201dc622ad7c39f255d.png";